import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { useAppXrResource } from './useAppXrResource';
import type { SandboxXrSpec } from './sandboxXrTypes';

const rowSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: 0.5,
};
const labelSx = { color: 'text.secondary', fontSize: '0.85rem' };
const valueSx = { fontSize: '0.85rem', fontFamily: 'monospace' };

export const SandboxConfigCard = () => {
  const { resource, loading } = useAppXrResource();
  const spec = resource?.spec as SandboxXrSpec | undefined;

  if (loading || !spec) return null;

  const dbSize = spec.database?.mysql?.size ?? spec.database?.postgres?.size;

  return (
    <Card>
      <CardHeader title="Sandbox Configuration" />
      <CardContent>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Region</Typography>
          <Typography sx={valueSx}>{spec.region ?? '—'}</Typography>
        </Box>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Database Size</Typography>
          <Typography sx={valueSx}>{dbSize ?? '—'}</Typography>
        </Box>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>TTL</Typography>
          <Typography sx={valueSx}>{spec.ttl ?? '—'}</Typography>
        </Box>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Mode</Typography>
          <Typography sx={valueSx}>{spec.mode ?? 'Managed'}</Typography>
        </Box>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Digistore</Typography>
          <Chip
            label={spec.deployDigistore ? 'Deployed' : 'Bare sandbox'}
            size="small"
            color={spec.deployDigistore ? 'primary' : 'default'}
            variant="outlined"
            sx={{ height: 20, '& .MuiChip-label': { px: 0.75 } }}
          />
        </Box>
        {spec.digistore?.pr && (
          <Box sx={rowSx}>
            <Typography sx={labelSx}>Pinned PR</Typography>
            <Typography sx={valueSx}>#{spec.digistore.pr}</Typography>
          </Box>
        )}
        {spec.digistore?.chartVersion && (
          <Box sx={rowSx}>
            <Typography sx={labelSx}>Chart</Typography>
            <Typography sx={valueSx}>{spec.digistore.chartVersion}</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
